import SchoolLogoGroupWrapper from './SchoolLogoGroupWrapper.component';

export default SchoolLogoGroupWrapper;